import React, { useState }  from 'react'
import axios from 'axios'
import { MdArrowLeft, MdArrowRight } from "react-icons/md"
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`

export default function BookHotelRoomUIFriendly() {
  const [schedule, setSchedule] = useState([])
  const [schedule1, setSchedule1] = 
  useState([])
  const [schedule2, setSchedule2] = useState([])
  const [calendar, setCalendar] = useState('schedule1')
  const [calendarData, setCalendarData] = useState()
  const [scheduleDisplay,setScheduleDisplay] = useState(false)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [msg, setMsg] = useState('')
  const [err, setErr] = useState('')
  const [reservation_data, setReservation_data] = useState([])
  const startDaysOfTheWeekList = ['Sun','Mon','Tue','Wed','Thu','Fri', 'Sat']
  function join(date, options, separator) {
    function format(option) {
      let formatter = new Intl.DateTimeFormat('en', option)
      return formatter.format(date)
    }
    return options.map(format).join(separator)
  }
  const today = join(new Date(), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
  const today_plus_3days_timestamp = new Date(`${today.slice(5,7)}/${today.slice(8,10)}/${today.slice(0,4)}`).getTime()+(1000*60*60*24*3)
  // user can book from 
  const today_plus_3days_format = join(new Date(today_plus_3days_timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
  const today_plus_90days_timestamp = new Date().getTime()+(1000*60*60*24*90)
  const today_plus_90days_format = join(new Date(today_plus_90days_timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
  const onClick2CreateScheduleMenu = async()=>{
  function getDaysInMonthUTC(m, y) {
    var date = new Date(Date.UTC(y, m, 1))
    var startDaysOfTheWeek = ''
    var d = []
    while (date.getUTCMonth() === m) {
      if(startDaysOfTheWeek==''){
        startDaysOfTheWeek =new Date(date).toString().slice(0,3)
        console.log(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        if(startDaysOfTheWeek=='Mon'){
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Tue'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Wed'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -2))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}],'-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Thu'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -3))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -2))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Fri'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -4))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -3))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -2))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }else if(startDaysOfTheWeek=='Sat'){
          d.push(join(new Date(new Date(Date.UTC(y, m, -5))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -4))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -3))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -2))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, -1))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
          d.push(join(new Date(new Date(Date.UTC(y, m, 0))), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        }
      }
        d.push(join(new Date(date), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-'))
        date.setUTCDate(date.getUTCDate() + 1)
      }
      return d
  }
  setSchedule1(getDaysInMonthUTC(join(new Date(), [{month: 'numeric'}])-1,join(new Date(), [{year: 'numeric'}])))
  setSchedule2(getDaysInMonthUTC(Number(join(new Date(), [{month: 'numeric'}])),2025))
    // setMsg('')
    // let mtg_timesheet={}
    // for(let i1=3;i1<33;i1++){
    //   const timestamp = new Date(`${today.slice(5,7)}/${today.slice(8,10)}/${today.slice(0,4)}`).getTime()+(1000*60*60*24*i1)
    //   const format = join(new Date(timestamp), [{year: 'numeric'},{month: '2-digit'},{day: '2-digit'}], '-')
    //   mtg_timesheet[`${format}`] = [{"10.00-11.00":"F"},{"13.00-14.00":"F"},{"14.00-15.00":"F"}]
    // } 
    // let reservation_data2 = ''
    // try {
    //   const { data: res } = await axios.get(`${APIURL}/basic/interview-mtg`)
    //   setReservation_data(res.info)
    //   reservation_data2 = res.info
    // } catch (err) {
    //   console.log(err)
    // }
    // for(let i2 = 0; i2<Object.keys(reservation_data2).length;i2++){
    //   let dataset = [{"10.00-11.00":"F"},{"13.00-14.00":"F"},{"14.00-15.00":"F"}]
    //   for(let i3 = 0; i3<Object.values(reservation_data2)[i2].length;i3++){
    //     if(Object.keys(Object.values(reservation_data2)[i2][i3])=="10.00-11.00"){
    //       dataset[0]={"10.00-11.00":"T"}
    //     }else if(Object.keys(Object.values(reservation_data2)[i2][i3])=="13.00-14.00"){
    //       dataset[1]={"13.00-14.00":"T"}
    //     }else{
    //       dataset[2]={"14.00-15.00":"T"}
    //     }
    //   }
    //   mtg_timesheet[Object.keys(reservation_data2)[i2]]=dataset
    // }
    // setSchedule(mtg_timesheet)
    setScheduleDisplay(true)
    }
    const onChange2StartDate = (e) => { 
      setStartDate(e.target.value)
    } 
    const onChange2EndDate = (e) => { 
      setEndDate(e.target.value)
    } 
    const onClick2Submit = ()=>{
      setErr('')
      setMsg('')
      function join(date, options, separator) {
      function format(option) {
          let formatter = new Intl.DateTimeFormat('en', option)
          return formatter.format(date)
      }
      return options.map(format).join(separator)
     }
     const startdate_plus_7days_timestamp = new Date(`${startDate.slice(5,7)}/${startDate.slice(8,10)}/${startDate.slice(0,4)}`).getTime()+(1000*60*60*24*7)
     const checkTerm = new Date(`${endDate.slice(5,7)}/${endDate.slice(8,10)}/${endDate.slice(0,4)}`).getTime()
      if(startDate==''){
        setErr('Please input start date.')
      }else if(endDate==''){
        setErr('Please input end date.')
      }else if(checkTerm<startdate_plus_7days_timestamp){
        setErr('You can only contract at least 7days of term.')
      }else{
        setMsg(`You are successfully submitted. Your contract starts on ${new Date(startDate).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} and ends on ${new Date(endDate).toLocaleDateString("en-US", { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}.`)
        setScheduleDisplay(false)
      }
    }
    return (
      <div>
      <div className='text-xs flex flex-col'>
      <button className='primary-btn w-fit mb-1' onClick={onClick2CreateScheduleMenu} disabled={scheduleDisplay}>Reserve your room</button>
      <div>
      {scheduleDisplay?<div className='w-fit mt-4'>
        <div className='flex'>
        <div className='flex flex-col mr-4'>
        <div className='flex justify-between mb-1'><MdArrowLeft className='mt-auto mb-auto'/><span className='mt-auto mb-auto'>07</span><MdArrowRight style={{visibility:'hidden'}} className='mt-auto mb-auto'/></div>
        <div className='flex'>{startDaysOfTheWeekList.map(x=><div className='text-center text-[8px] w-[28px]'>{x}</div>)}</div>
        <div className='grid grid-cols-7'>
        {schedule1.map((x)=><div className='text-center text-[8px] w-[28px]'><span className={`${x.slice(5,7)!=schedule1[15].slice(5,7)?'text-gray-400':'hover:rounded-[100px] hover:bg-gray-100'} p-1  cursor-default`}>{x.slice(x.length-2,x.length)}</span></div>)}</div>  
        </div>
        <div className='flex flex-col'>
        <div className='flex justify-between mb-1'><MdArrowLeft style={{visibility:'hidden'}} className='mt-auto mb-auto'/><span className='mt-auto mb-auto'>08</span><MdArrowRight className='mt-auto mb-auto'/></div>
        <div className='flex'>{startDaysOfTheWeekList.map(x=><div className='text-center text-[8px] w-[28px]'>{x}</div>)}</div>
        <div className='grid grid-cols-7'>
        {schedule2.map((x)=><div className='text-center text-[8px] w-[28px]'><span className={`${x.slice(5,7)!=schedule2[15].slice(5,7)?'text-gray-400':'hover:rounded-[100px] hover:bg-gray-100'} p-1  cursor-default`}>{x.slice(x.length-2,x.length)}</span></div>)}
        </div>
        </div>
        </div>
      <div className='flex'>
        <div className='flex flex-col mr-2'>
          <label for='reservation_start_date'>Start Date</label>
          <input type='date' id='reservation_start_date' name='reservation_date' min={today_plus_3days_format} max={today_plus_90days_format} value={startDate}
          onChange={(x)=>onChange2StartDate(x)} 
          className={`${err!=''?'border-red-600':'border-gray-900'} border w-fit`}/>
        </div>
        <div className='flex flex-col'>
          <label for='reservation_end_date'>End Date</label>
          <input type='date' id='reservation_end_date' name='reservation_date' min={startDate}  value={endDate} 
          onChange={(x)=>onChange2EndDate(x)} 
          className={`${err!=''?'border-red-600':'border-gray-900'} border w-fit`}/>
        </div>
      </div>
      {err!='' ? <p className='text-xs text-red-700'>{err}</p>:''} 
      <div className='flex'><div className='primary-btn w-fit mr-1' onClick={()=>setScheduleDisplay(!scheduleDisplay)}>Cancel</div><button className='primary-btn text-xs w-fit' onClick={onClick2Submit}>Submit</button></div>
      </div>:''}
      </div>
      {msg!='' ? <span className='text-xs'>{msg}</span>:''} 
      </div>
      </div>
      )
  }